import PipelineDialog from './PipelineDialog'

export default PipelineDialog
